import React from "react";
import { Step1 } from "./SVGIcon";

const Step = ({ image, title, description, titleStep }) => {
  return (
    <div className="steps ">
      {/* <img src={image} alt={title} /> */}
      {image}
      <div className="bottom">
        <p>{titleStep}</p>
        <h3>{title}</h3>
      </div>
    </div>
  );
};

export default Step;
